import * as React from "react";

import { ExperienceSelector } from "@origin-digital/features";
import { Interstitial } from "@origin-digital/personalisation";
import { isNative } from "@origin-digital/platform-helpers";

export const StaticPageInterstitial = ({ mbox }) => {
  if (isNative()) {
    return null;
  }

  return (
    <ExperienceSelector mbox={mbox}>
      {(content) => <Interstitial content={content} />}
    </ExperienceSelector>
  );
};
